/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/ArticlePaywall/Form/theme';

export const ArticlePaywallFormTheme = theme;
